import React from 'react';

const StyleSelector = ({ setFont, setLineStyle }) => {
  const fonts = ['Cursive', 'Print', 'Comic Sans', 'Serif', 'Sans-serif', 'Monospace', 'Brush Script', 'Dancing Script', 'Pacifico', 'Indie Flower'];
  const lines = ['none', 'ruled', 'grid', 'dotted'];

  return (
    <div className="style-selector">
      <label>Handwriting Style:</label>
      <select onChange={(e) => setFont(e.target.value)}>
        {fonts.map((font, idx) => (
          <option key={idx} value={font}>{font}</option>
        ))}
      </select>

      <label>Line Style:</label>
      <select onChange={(e) => setLineStyle(e.target.value)}>
        {lines.map((line, idx) => (
          <option key={idx} value={line}>{line}</option>
        ))}
      </select>
    </div>
  );
};

export default StyleSelector;
